<template>
  <div class="container">
    <div class="infoss">
      <div class="tit">{{ $t('auth').AssetCertification }}</div>
      <div class="info">
        <!-- 账户类型 -->
        <div class="item">
          <div class="lable">{{ $t('auth').AccountType }}</div>
          <PopoverSelect :items="cardTypeActions" :onSelect="onSelect">
            <template #reference>
              <van-field v-model="authInfo.cardTypeTxt" readonly right-icon="arrow-down">
              </van-field>
            </template>
          </PopoverSelect>
        </div>
        <!-- 持有金额 -->
        <div class="item">
          <div class="lable">{{ $t('auth').holdingamount }}</div>
          <van-field v-model="authInfo.amount" type="number" :placeholder="$t('recharge').amountMsg" :readonly="BaseReadonlyFlag">
          </van-field>
        </div>
        <!-- 账户截图 -->
        <div class="item">
          <div class="lable">{{ $t('auth').Accountscreenshot }}</div>
          <div class="up_img">
            <van-uploader :after-read="justAfterRead" :disabled="BaseReadonlyFlag">
              <img v-if="authInfo.imgs" :src="baseUrl + authInfo.imgs" />
              <van-icon v-else name="photo-o" color="var(--text_color)" size="50" />
            </van-uploader>
          </div>
        </div>
        <!-- 按钮 -->
        <van-button v-if="!BaseReadonlyFlag" block :loading="btnloading" @click="handleSubBase">{{ $t('auth').btn
        }}</van-button>
        <div class="tips" v-if="authInfo.auditStatus == '1'">{{ $t('auth').wait }}</div>
        <div class="tips" v-if="authInfo.auditStatus == '2'">{{ $t('auth').success }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import PopoverSelect from '@/components/popoverSelect.vue'
import { EventBus } from '@/utils/event-bus'

export default {
  components: {
    PopoverSelect,
  },
  data() {
    return {
      btnloading: false,
      baseUrl: window.baseURL,
      BaseReadonlyFlag: false,//认证修改
      showPopover: false,
      authInfo: {
        authenticationType: '1',
        cardTypeTxt: this.$t('auth').bankaccount,
        amount: '',
        imgs: '',
        auditStatus: '',
      },
    }
  },
  computed: {
    cardTypeActions() {
      return [
        { text: this.$t('auth').bankaccount, val: '1' },
        { text: this.$t('auth').IRAaccount, val: '2' },
        { text: this.$t('auth').stockaccount, val: '3' },
        { text: this.$t('auth').other, val: '4' },
      ]
    },
  },
  mounted() {
    EventBus.$on('btnloading', () => {
      this.btnloading = false
    })
    this.getMemberAuthAsset()
  },
  methods: {
    showSelect() {
      if (this.BaseReadonlyFlag) return;
      this.showPopover = true
    },
    //选择证件类型
    async onSelect(action) {
      this.authInfo.authenticationType = action.val
      this.authInfo.cardTypeTxt = action.text
    },
    // 获取认证信息
    async getMemberAuthAsset() {
      const res = await userApi.getMemberAuthAsset()
      if (res.data) {
        this.authInfo = res.data
        this.authInfo.cardTypeTxt = this.cardTypeActions.find(item => item.val === this.authInfo.authenticationType)?.text || ''
        this.BaseReadonlyFlag = this.authInfo.auditStatus === '1' || this.authInfo.auditStatus === '2'
      }
    },
    // 账户截图
    async justAfterRead(file) {
      const formdata = new FormData()
      formdata.append('file', file.file)
      var res = await systemApi.UploadFile(formdata)
      this.authInfo.imgs = res.fileName
    },
    // 提交认证
    async handleSubBase() {
      if (!this.authInfo.authenticationType) {
        this.$toast(this.$t('auth').AccountTypetips)
        return false
      }
      if (!this.authInfo.amount) {
        this.$toast(this.$t('recharge').amountMsg)
        return false
      }
      if (!this.authInfo.imgs) {
        this.$toast(this.$t('auth').Accountscreenshottips)
        return false
      }
      const form = {
        authenticationType: this.authInfo.authenticationType,
        amount: this.authInfo.amount,
        imgs: this.authInfo.imgs,
      }
      this.btnloading = true
      await userApi.authAsset(form)
      this.btnloading = false
      this.$toast({ message: this.$t('auth').subMsg })
      this.$router.go(-1)
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);
  padding-top: 110px;
  padding-bottom: 100px;

  .infoss {
    margin: 0 auto;
    max-width: 780px;

    .tit {
      font-size: 36px;
      font-weight: bold;
      color: var(--text_color);
    }
  }

  .info {
    margin-top: 30px;

    .lable {
      font-size: 15px;
      color: var(--ntext_color);
      margin-bottom: 20px;
    }

    .selbtn {
      background: var(--background_color);
      padding: 0 15px 0 15px;
      border-radius: 10px;
      font-size: 13px;
      color: var(--text_color);
      height: 40px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
    }

    .up_img {
      width: 170px;
      height: 107px;
      border-radius: 10px;
      background: var(--info_color);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      img {
        width: 170px;
        height: 107px;
        border-radius: 10px;
      }
    }

    .tips {
      margin-top: 70px;
      text-align: center;
      font-size: 17px;
      font-weight: bold;
      color: var(--text_color);
    }

    .upbtn {
      margin-top: 20px;
      text-align: center;
      font-size: 13px;
      color: var(--ntext_color);
    }
  }

  .line {
    margin-bottom: 20px;
    height: 7px;
    background: var(--info_color);
  }
}

.vue-country-popover-container {
  width: 100%;
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 14px;
  opacity: 0.9;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 10px;
  height: 40px;
  margin-bottom: 30px;
  border-radius: 10px;
  font-size: 15px;
  border: 1px solid var(--info_color);

  &:hover {
    border: 1px solid var(--primary_color);
  }
}

::v-deep .van-button {
  margin-top: 50px;
  background: var(--primary_color);
  height: 40px;
  border-radius: 20px;
  border: 0;
  font-size: 15px;
  color: #fff;
}

::v-deep .van-button:hover {
  opacity: 0.8;
}
</style>
